import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GenericDocContainerModel } from "../../../../../../models/aggregates/generic_doc";
import {
  ApiVisa,
  BaseApiTemplateService,
  Core2Config,
  Pagination,
  PagingResponseModel,
} from "../../shared";
import { BaseGenDocTypeService } from "./base-generic-doc-hdr.service";

@Injectable({
  providedIn: "root",
})
export class InternalStockRequisitionService extends BaseGenDocTypeService {
  // readonly url = Core2Config.LOCAL_HOST +
  //   Core2Config.TENANT_URL_PREFIX +
  //   Core2Config.DOMAIN_PREFIX +
  //   Core2Config.ERP_PREFIX +
  //   Core2Config.GENERIC_PREFIX +
  //   "internal-stock-requisition";

  constructor(http: HttpClient) {
    super(http, 'internal-stock-requisition');
    // this.endpoint_path =
    //   Core2Config.TENANT_URL_PREFIX +
    //   Core2Config.DOMAIN_PREFIX +
    //   Core2Config.ERP_PREFIX +
    //   Core2Config.GENERIC_PREFIX +
    //   "internal-stock-requisition";
  }

  getLinesByCriteria(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = `${visa.api_domain_url}${this.endpoint_path}/type`;
    }
    const UrlByCriteria =
      this.apiUrl + "/query?" + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<GenericDocContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  printPdf(
    guid: string,
    templateDocId: string,
    printServiceClassName: string,
    apiVisa: ApiVisa
  ): Observable<Blob> {
    return this.httpClient.get<Blob>(this.apiUrl + "/print-pdf/" + guid, {
      headers: new HttpHeaders({
        authorization: apiVisa.jwt_secret,
        responseType: "blob",
        tenantCode: apiVisa.tenantCode,
      }),
      params: new HttpParams()
        .set("templateDocId", templateDocId)
        .set("printServiceClassName", printServiceClassName),
      responseType: "blob" as "json",
    });
  }

  public printJasperPdf(
    guid: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    printServiceClassName?: string,
    customParam?: string
  ): Observable<Blob> {
    let params;
    let url;
    
    if(printServiceClassName && !customParam) {
      params = new HttpParams()
      .set("printServiceClassName", printServiceClassName)
      .set("printableFormatHdrGuid", printableFormatGuid)
      .set("printServiceClassName", printServiceClassName);
    }
    else if (customParam && !printServiceClassName) {
      params = new HttpParams()
      .set("printServiceClassName", printServiceClassName)
      .set("printableFormatHdrGuid", printableFormatGuid)
      .set("customParam", customParam);
    }
    else if(printServiceClassName && customParam){
      params = new HttpParams()
      .set("printServiceClassName", printServiceClassName)
      .set("printableFormatHdrGuid", printableFormatGuid)
      .set("printServiceClassName", printServiceClassName)
      .set("customParam", customParam);
    }
    else{
      params = new HttpParams()
      .set("printServiceClassName", printServiceClassName)
      .set("printableFormatHdrGuid", printableFormatGuid)
    }
    url = apiVisa.api_domain_url + this.endpoint_path + '/print-jasper-pdf/' + guid;
    return this.httpClient.get<Blob>(
      url,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }
}
